// 三个常量先放置于此
// 响应成功code
const SUCCESS_CODE = '0';
// 超时时长
const TIMEOUT = 30 * 1000;

// 已注销
const LOGOFF_CODE = '40012211';

export { SUCCESS_CODE, TIMEOUT, LOGOFF_CODE };
